import React from "react";

const Printer = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.50033V1.66699H15V7.50033"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00008 15H3.33341C2.89139 15 2.46746 14.8244 2.1549 14.5118C1.84234 14.1993 1.66675 13.7754 1.66675 13.3333V9.16667C1.66675 8.72464 1.84234 8.30072 2.1549 7.98816C2.46746 7.6756 2.89139 7.5 3.33341 7.5H16.6667C17.1088 7.5 17.5327 7.6756 17.8453 7.98816C18.1578 8.30072 18.3334 8.72464 18.3334 9.16667V13.3333C18.3334 13.7754 18.1578 14.1993 17.8453 14.5118C17.5327 14.8244 17.1088 15 16.6667 15H15.0001"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 11.667H5V18.3337H15V11.667Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Printer;
